import React from 'react';
import Banner from '../Banner/Banner';
import ParticlesBanner from '../ParticlesBanner/ParticlesBanner';

const WelcomePage = () => {
    return (
        <div>
            <Banner></Banner>
            {/* <ParticlesBanner></ParticlesBanner> */}


        </div>
    );
};

export default WelcomePage;